import type React from 'react';

import type { Event } from '@vlabs/api/luna-api/model';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';

import {
  DeepfakeAttributeCard,
  LivenessAttributeCard,
  TemperatureAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards';

import st from './AttributesCell.module.sass';
import { AttributesCellBase } from './AttributesCellBase';

interface AttributesCellLunaProps extends WithClassNameProp, WithDataTestid {
  event?: Event;
}

function getTemperature(userData?: string): number | null {
  if (!userData) return null;

  try {
    const { t } = JSON.parse(userData) as { t?: number | null };

    if (t === null || t === undefined) return null;

    return Number(t.toFixed(1));
  } catch {
    return null;
  }
}

function AttributesCellLuna({
  event = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: AttributesCellLunaProps): React.JSX.Element | null {
  const temperature = getTemperature(event?.user_data);

  return (
    <AttributesCellBase
      className={className}
      data-testid={dataTestId}
      displayName="AttributesCellLuna"
      event={event}
    >
      {temperature !== null && (
        <TemperatureAttributeCard
          className={st.AttributeCard}
          temperature={temperature}
        />
      )}

      <LivenessAttributeCard
        className={st.AttributeCard}
        liveness={event?.liveness ?? null}
      />

      <DeepfakeAttributeCard
        className={st.AttributeCard}
        deepfake={event?.deepfake ?? null}
      />
    </AttributesCellBase>
  );
}

AttributesCellLuna.displayName = 'AttributesCellLuna';

export { AttributesCellLuna };
